import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
  :root {
    --primary: #3b82f6;
    --primary-hover: #2563eb;
    --success: #22c55e;
    --warning: #eab308;
    --error: #ef4444;
    --gray-50: #f9fafb;
    --gray-100: #f3f4f6;
    --gray-200: #e5e7eb;
    --gray-300: #d1d5db;
    --gray-600: #4b5563;
    --gray-700: #374151;
    --gray-800: #1f2937;
    --gray-900: #111827;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    line-height: 1.5;
    min-height: 100vh;
    padding: 1rem;
  }

  .container-redirect {
    max-width: 64rem;
    margin: 0 auto;
    width: 100%;
  }

  .container-redirect .header {
    text-align: center;
    margin-bottom: 2rem;
  }

  .container-redirect .header h1 {
    font-size: clamp(1.5rem, 5vw, 2rem);
    color: #111827;
    margin-bottom: 0.75rem;
  }

  .container-redirect .header p {
    font-size: clamp(0.875rem, 4vw, 1rem);
    color: #4b5563;
  }

  .container-redirect .url-form {
    margin-bottom: 1.5rem;
  }

  .container-redirect .input-group-box {
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
  }

  .container-redirect .input_checker {
    width: 85%;
    padding: 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    font-size: clamp(0.875rem, 4vw, 1rem);
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .container-redirect .input_checker:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .container-redirect button {
    padding: 0.75rem;
    background-color: #3b82f6;
    color: white;
    border: none;
    border-radius: 0.5rem;
    font-weight: 600;
    font-size: clamp(0.875rem, 4vw, 1rem);
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    min-height: 44px; /* Touch-friendly size */
  }

  .container-redirect button:hover {
    background-color: #2563eb;
  }

  .container-redirect button:disabled {
    background-color: #d1d5db;
    cursor: not-allowed;
  }

  .container-redirect .spinner {
    width: 1.25rem;
    height: 1.25rem;
    border: 2px solid white;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .container-redirect .error-message {
    margin-top: 0.75rem;
    padding: 0.75rem;
    background-color: #fef2f2;
    border-radius: 0.5rem;
    color: #ef4444;
    font-size: clamp(0.75rem, 3.5vw, 0.875rem);
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .container-redirect .card {
    background: white;
    border-radius: 0.75rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 1rem;
    margin-bottom: 1.5rem;
  }

  .container-redirect .score-card .score-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
  }

  .container-redirect .score {
    font-size: clamp(1.5rem, 6vw, 2rem);
    font-weight: bold;
  }

  .container-redirect .score.excellent {
    color: #22c55e;
  }
  .container-redirect .score.good {
    color: #3b82f6;
  }
  .container-redirect .score.fair {
    color: #eab308;
  }
  .container-redirect .score.poor {
    color: #ef4444;
  }

  .container-redirect .score-message {
    color: #4b5563;
    font-size: clamp(0.75rem, 3.5vw, 0.875rem);
  }

  .container-redirect .table-container {
    overflow-x: auto;
    margin-top: 1rem;
  }

  .container-redirect table {
    width: 100%;
    border-collapse: collapse;
  }

  .container-redirect th,
  .container-redirect td {
    padding: 0.5rem;
    text-align: left;
    border-bottom: 1px solid #e5e7eb;
    font-size: clamp(0.75rem, 3.5vw, 0.875rem);
  }

  .container-redirect th {
    font-weight: 600;
    color: #4b5563;
  }

  .container-redirect .view-headers-btn {
    background: none;
    border: 1px solid #3b82f6;
    color: #3b82f6;
    padding: 0.25rem 0.5rem;
    font-size: clamp(0.75rem, 3.5vw, 0.875rem);
    border-radius: 0.25rem;
    min-height: 36px; /* Touch-friendly size */
  }

  .container-redirect .view-headers-btn:hover {
    background: #3b82f6;
    color: white;
  }

  .container-redirect .headers-detail {
    display: none;
  }

  .container-redirect .headers-detail.active {
    display: block;
  }

  .container-redirect .headers-content {
    font-family: monospace;
    white-space: pre-wrap;
    background: #f9fafb;
    padding: 0.75rem;
    border-radius: 0.5rem;
    max-height: 300px;
    overflow-y: auto;
    font-size: clamp(0.75rem, 3.5vw, 0.875rem);
  }

  .container-redirect .status-code {
    font-weight: 600;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
  }

  .container-redirect .status-code.success {
    background-color: #6ac788;
    color: #fff;
  }

  .container-redirect .status-code.redirect {
    background-color: #72c1fc;
    color: #fff;
  }

  .container-redirect .status-code.error {
    background-color: #ef4444;
    color: #fff;
  }

  .container-redirect .recommendations-card {
    background: linear-gradient(to right bottom, #ffffff, #f8fafc);
  }

  .container-redirect .recommendations-list {
    list-style: none;
    padding: 0;
  }

  .container-redirect .recommendations-list li {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 0.5rem;
    border: 1px solid #e5e7eb;
    font-size: clamp(0.75rem, 3.5vw, 0.875rem);
  }

  .container-redirect .recommendations-list li svg {
    flex-shrink: 0;
    margin-top: 0.25rem;
  }

  .container-redirect .recommendations-list li:last-child {
    margin-bottom: 0;
  }

  .container-redirect .actions {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 1.5rem;
  }

  .container-redirect .action-button {
    background: white;
    color: #374151;
    border: 1px solid #d1d5db;
    padding: 0.5rem;
    font-size: clamp(0.75rem, 3.5vw, 0.875rem);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    min-height: 44px; /* Touch-friendly size */
  }

  .container-redirect .action-button:hover {
    background: #f9fafb;
  }

  .container-redirect .hidden {
    display: none;
  }

  @media (max-width: 412px) {
.container-redirect .input-group-box {
      flex-direction: column;
    }

}

  @media (max-width: 768px) and (min-width: 413px) {
.container-redirect .input-group-box {
      flex-direction: row;
    }
    .container-redirect button {
    width: 37% !important;
    padding: 0.75rem;
    background-color: #3b82f6;
    color: white;
    border: none;
    border-radius: 0.5rem;
    font-weight: 600;
    font-size: clamp(0.875rem, 4vw, 1rem);
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    min-height: 44px;
}
}

  /* Mobile-specific styles */
  @media (max-width: 768px) {
    body {
      padding: 0.5rem;
    }

    .container-redirect {
      max-width: 100%;
      padding: 0 0.5rem;
    }

    

    .container-redirect .input_checker {
      width: 100%;
    }


    .container-redirect .card {
      padding: 0.75rem;
      margin-bottom: 1rem;
    }

    .container-redirect .score-card .score-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .container-redirect .score {
      font-size: clamp(1.25rem, 5vw, 1.5rem);
    }

    .container-redirect .table-container {
      overflow-x: auto;
      width: 100%;
    }

    .container-redirect table {
      display: block;
    }

    .container-redirect thead {
      display: none; /* Hide table headers on mobile */
    }

    .container-redirect tbody,
    .container-redirect tr {
      display: block;
    }

    .container-redirect tr {
      margin-bottom: 1rem;
      border: 1px solid #e5e7eb;
      border-radius: 0.5rem;
      padding: 0.5rem;
      background: #f9fafb;
    }

    .container-redirect td {
      display: flex;
      justify-content: space-between;
      padding: 0.25rem 0.5rem;
      border-bottom: none;
    }

    .container-redirect td::before {
      content: attr(data-label);
      font-weight: 600;
      color: #4b5563;
      width: 40%;
    }

    .container-redirect td:nth-child(1)::before {
      content: "URL";
    }
    .container-redirect td:nth-child(2)::before {
      content: "STATUS CODE";
    }
    .container-redirect td:nth-child(3)::before {
      content: "REDIRECT NOTE";
    }
    .container-redirect td:nth-child(4)::before {
      content: "REDIRECTS";
    }
    .container-redirect td:nth-child(5)::before {
      content: "FINAL URL";
    }
    .container-redirect td:nth-child(6)::before {
      content: "FINAL URL STATUS CODE";
    }

    .container-redirect .actions {
      flex-direction: column;
    }

    .container-redirect .action-button {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    .container-redirect .header h1 {
      font-size: clamp(1.25rem, 4.5vw, 1.5rem);
    }

    .container-redirect .header p {
      font-size: clamp(0.75rem, 3.5vw, 0.875rem);
    }

    .container-redirect .input_checker {
      font-size: clamp(0.75rem, 3.5vw, 0.875rem);
    }

    .container-redirect button {
      font-size: clamp(0.75rem, 3.5vw, 0.875rem);
    }
  }
    @media (min-width: 769px) and (max-width: 1200px) {
  .container-redirect .input-group-box {
    flex-wrap: nowrap;       
    align-items: center;
  }

    .container-redirect .input_checker {
      flex: 1;
      width: auto;
    }

    .container-redirect .checker_button {
      flex-shrink: 0;
      white-space: nowrap;
    }
  }
`;
